<template>
  <div class="space-bottom">
    <IQOS :title="$t('subscriptions.promo.title')">
      <div class="promo-box">
        <p class="title">
          {{$t('subscriptions.promo.input')}}
        </p>

        <div class="action">
          <input :placeholder="$t('transactions.promo.input_hint')" class="w-100 align-self-end" v-model="promocode" />
          <button :disabled="isDisable" class="connect" @click="use">{{$t('subscriptions.promo.connect')}}</button>
        </div>
      </div>
    </IQOS>
  </div>
</template>

<style scoped>
div {
  width: 86.5vh;
}

p.title {
  width: 55%;
}

.action {
  width: 40%;
  display: flex;
  flex-flow: column;
}
.action input {
  border-radius: 1vh;
  font-size: 2vh;
  border: none;
  text-align: center;
  outline: none;
  padding: 0.6vh 1vh;
}

.space-bottom {
  margin-bottom: 3vh;
}

.promo-box {
  display: flex;
  justify-content: space-between;
  position: relative;
  width: auto;
}
button.connect {
  cursor: pointer;
  background: #129b81;
  width: 100%;
  color: #ededed;
  border: none;
  outline: none;
  margin-top: 2.2vh;
  font-size: 2vh;
  padding: 0.8vh 0;
  border-radius: 1vh;
  align-self: flex-end;
}

button:disabled {
  opacity: 0.6;
}
</style>

<script>
import IQOS from "@/components/IQOS.vue";
import BlackInput from "@/components/BlackInput.vue";

import SubscriptionAPI from "@/api/subscription"

export default {
  data() {
    return {
      promocode: ""
    };
  },
  components: {
    IQOS,
    BlackInput
  },
  methods: {
    use() {
      SubscriptionAPI.usePromocode(this.promocode).then(data => {
        this.$store.commit('setSubscription', data.subscription);
        this.promocode = '';
      }).catch(error => {
        alert('Промокод невірний.');
        this.promocode = '';
      });
    }
  }, 
  computed: {
    isDisable() {
      return !this.promocode;
    }
  }
};
</script>